const TcpSocketConnection = require('@/libraries/DigiTickets/TcpSocketConnection');

/**
 * An extension of TcpSocketConnection that prevents sending messages to the TCP socket too fast by putting
 * them into a queue and only sending 1 message every x milliseconds.
 * You must call setSendMessageInterval with a number of milliseconds to start the interval before any messages
 * will send.
 */
class DebouncedTcpSocketConnection extends TcpSocketConnection {
    constructor(name, host, port, agentService) {
        super(name, host, port, agentService);

        /**
         * @type {{dataString: string, callback: Function}[]}
         */
        this.sendDataQueue = [];

        this.sendMessageInterval = null;
    }

    /**
     * Send some data over the TCP socket (via the WebSocket).
     *
     * @param {string} dataString
     * @param {Function} [callback]
     */
    sendData(dataString, callback) {
        this.sendDataQueue.push({
            dataString,
            callback,
        });
    }

    /**
     * @param {number} milliseconds
     */
    setSendMessageInterval(milliseconds) {
        if (this.sendMessageInterval !== null) {
            clearInterval(this.sendMessageInterval);
        }

        this.sendMessageInterval = setInterval(
            () => {
                const nextDataToSend = this.sendDataQueue.shift();
                if (nextDataToSend !== undefined) {
                    super.sendData(nextDataToSend.dataString, nextDataToSend.callback);
                }
            },
            milliseconds
        );
    }
}

module.exports = DebouncedTcpSocketConnection;
